import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export async function callApi(key: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/UserSetting/${key}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export type Response = {
	data: string;
};

export type ResponseData = string;
